<template>
    <div class="audio-recorder">
        <audio-recorder :afterRecording="callback" :show-upload-button="false"></audio-recorder>
    </div>
</template>

<script>
// Vue.use(VueAudioRecorder)
import VueAudioRecorder from 'vue-audio-recorder';
export default {
    data : function () {
        return {
            media : null,
            recording : false
        }
    },
    components : {
        VueAudioRecorder
    },
    props : {
        setMedia : Function
    },
    methods : {
        canRecord : function () {
            return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
        },
        startRecording : function () {
            if (this.recording) {
                return;
            }
            this.recording = true;
        },
        stopRecording : function () {
            if (!this.recording) {
                return;
            }
            this.recording = false;
        },
        callback (msg) {
            let self = this;
            this.setMedia(msg.blob); // audio is a blob object
            // var reader = new FileReader();
            // reader.readAsDataURL(msg.blob);
            // reader.onloadend = function() {
            //     var base64data = reader.result;
            //     self.setMedia(base64data);
            // }
        }
    }
}
</script>
